"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _getNestedPropertiesAsStrings = _interopRequireDefault(require("redux-less/utils/getNestedPropertiesAsStrings"));

var createActionHandlersForNestedProperty = function createActionHandlersForNestedProperty(_ref) {
  var actionTypes = _ref.actionTypes,
      property = _ref.property;
  var nestedPropertiesAsStrings = (0, _getNestedPropertiesAsStrings.default)(property);
  return nestedPropertiesAsStrings.reduce(function (acc, prop) {
    return Object.assign({}, acc, (0, _defineProperty2.default)({}, actionTypes[prop], function (state, action) {
      return state.setIn(prop.split("/"), action.payload[prop]);
    }));
  }, {});
};

var _default = createActionHandlersForNestedProperty;
exports.default = _default;
module.exports = exports.default;